import React from "react";
import { object, string, bool } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/card-image";
import TimeStamp from "../../atoms/time-stamp";
import SocialShareBottom from "../../story-templates/social-share";
import useStorage from "../../../hook/useStorage";
import { isFreeLimit } from "../../utils/isFreeLimit";
import "./story-header-wow.m.css";
import aspectRatio from "../../utils/aspectRatio";

const StoryHeaderWow = ({ story, isHeroImage = true }) => {
  const imgS3keys = story["hero-image-s3-key"];
  const paikkakunta = get(story, ["metadata", "paikkakunta"], []);
  const ingressi = get(story, ["metadata", "ingressi"], []);
  const publishTime = story["published-at"];
  const updateTime = story["updated-at"];
  var storyUpdated = false;
  if (updateTime > publishTime) {
    storyUpdated = true;
  }
  var colorTheme = "default";
  if ((get(story, ["metadata", "story-attributes", "taustavariwaujuttuun", 0])) !== undefined) {
    colorTheme = get(story, ["metadata", "story-attributes", "taustavariwaujuttuun", 0]);
  }

  /* if there is a value in waujutunpaakuva, it is assigned to mainImg. Otherwise mainImg is '' (empty)  */
  var mainImg = get(story, ["metadata", "story-attributes", "waujutunpaakuva", 0]) !== undefined ? get(story, ["metadata", "story-attributes", "waujutunpaakuva", 0]) : '';
  const accessType = story.access;
  const [checkUser, activeProducts,whiteListed,allTagIds,visitCounts,articlesLimit,isVisitedSlug] = useStorage();
  const conditionalComponents = isFreeLimit(checkUser, activeProducts,visitCounts,articlesLimit,isVisitedSlug);

  /* getting url right regarding different papers*/

  function findByKey(key, value) {
    return (item, i) => item[key] === value
  }

  let findParams = findByKey("domain-slug", "ilkka-pohjalainen") //change here
  let positionOfPaper = story.sections.findIndex(findParams)

  // Check if there is section for that paper (needed mainly for localhost)
  var sectionUrl = story.sections[positionOfPaper] ? (story.sections[positionOfPaper]["section-url"]) : (story.sections[0]["section-url"])
  var sectionTag = story.sections[positionOfPaper] ? (((story.sections[positionOfPaper]["display-name"] !== "Epari") && (story.sections[positionOfPaper]["display-name"] !== "Vaasa-lehti")) ? story.sections[positionOfPaper]["display-name"] : "") : (story.sections[0]["display-name"]);
  const aspRto= aspectRatio(story);
  return (
    <div styleName={colorTheme} className={colorTheme}>
      <div styleName="wrapper">
        <div styleName="image-headline">
          {isHeroImage && (
            <React.Fragment>
              {imgS3keys && <div styleName={'card-img ' + mainImg}>
                <CardImage aspectRatio={[aspRto[1],aspRto[0]]} story={story} defaultWidth={500} imageType="imageOriginalShape" />
              </div>}
            </React.Fragment>
          )}
          {/*<div styleName="headline-wrapper">
            <h1 styleName="story-headline">{story.headline}</h1>
          </div>*/}
          </div>

        <div styleName="story-header-info">


          <div styleName="story-lead">{ingressi}</div>
          <div styleName="authors">
              {/*<Link href={`/author/${authorSlug}`} styleName="author-img">*/}
              <ul>
                {story.authors.map(author =>
                  <li>{author.name}</li>
                )}
              </ul>
              {/*</Link>*/}
          </div>
          <div styleName="section-time" className="voice-no-read">
            <div styleName="time-wrapper"><TimeStamp timeStamp={story["published-at"]} />
              {(storyUpdated === true) ? (
                <div styleName="story-updated"><TimeStamp timeStamp={story["updated-at"]} /></div>
              ) : (
                null
              )}
            </div>
          </div>
          {/* voice intuitive button to show only when the story component is showing instead of paywall */}
          <div className={`${((accessType === "login" || accessType === "subscription" || accessType === null) && (!checkUser || !conditionalComponents)) ?
            !whiteListed ? "" : "" : "voice-intuitive"}`} styleName="voice-intuitive-btn"></div>
          {/*{paikkakunta.length > 0 && (<div styleName="section-place">

            <Link styleName="place">{paikkakunta} </Link>
              </div>)}*/}
          <div styleName="social-share-top">
              <SocialShareBottom story={story} />
          </div>


        </div>
      </div>
    </div>
  );
};

StoryHeaderWow.propTypes = {
  story: object,
  sectionName: string,
  isHeroImage: bool
};

export default StoryHeaderWow;
